module.exports = __webpack_public_path__ + "img/semicolon.6fdcb82a.svg";